import { useMutation } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';
import { ISurveyMetadata } from 'features/seismic/models/interfaces/ISurveyMetadata';
import { IColorbar } from 'features/seismic/models/interfaces/IColorbar';

interface ISeismicMetadataResponse {
    Metadata: ISurveyMetadata;
    Resolutions: number[];
    Colorbar: IColorbar;
}

export type GetSeismicMetadataParams = {
    volumeToken: string;
};

export const useGetSeismicMetadata = () => {
    const { metadataHost, jwt } = useSessionStore(state => ({
        metadataHost: state.tenantConfiguration?.endpoints.metadata,
        jwt: state.jwtToken,
    }));

    return useMutation<ISurveyMetadata, unknown, GetSeismicMetadataParams>(
        async ({ volumeToken }) => {
            const response = await axios.get<IResponseAPI<ISeismicMetadataResponse>>(
                `${metadataHost}/Seismic/Volume/Metadata`,
                {
                    params: {
                        filePath: '',
                        volumeToken,
                        forceDisableCache: false,
                        tileWidth: 256,
                        tileHeight: 1080,
                        screenHeight: 885,
                        includePercentageCalc: true,
                        calcResolutions: true,
                        volumeIdentifier: 'volumeToken',
                        traceFieldFilter: '',
                        traceFieldValue: '',
                        defaultSort: '',
                    },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result.Metadata;
        }
    );
};
